import React from 'react'

const CheckoutSectionHeader = ({ label }) => (
    <header><h4 style={{ color: '#6ABAEC'}}>{label}</h4></header>
)

export default CheckoutSectionHeader